import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { WJAppModule } from './wj-app/wj-app.module';
import { environment } from '@moduurnv2/libs-orderingapp/src/core';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(WJAppModule)
  .catch((err) => console.error(err));
